<mat-toolbar  class="toolbar">
    <div mat-icon-button class="df-icon">
        <img class="logo" src=" ../../assets/images/dayforce-blue.svg">
    </div>

    <span class="toolbar-spacer-middle" *ngIf="!showPrimaryButtons"></span>
    <div class="buttons">
        <button *ngIf="strings" matTooltip="{{strings['logOff']}}" matTooltipPosition="below" mat-icon-button class="nav-icon" (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
        </button>
    </div>
</mat-toolbar>